import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/codebuild/output/src967172558/src/nextjs-grudder/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src967172558/src/nextjs-grudder/node_modules/next/dist/client/link.js");
